import React from "react";
import DashboardContents from "./DashboardContents";
import { connect } from "react-redux";
import FullPageSpinner from "../../FullPageSpinner";
import _ from "lodash";
import { myDashboard } from "../../../api/users";

class Dashboard extends React.Component {
  state = { myDashboard: null, time_window: "all" };
  async componentDidMount() {
    await this.fetchMyDashboard();
  }
  fetchMyDashboard = async () => {
    this.setState({ myDashboard: null });
    let { data } = await myDashboard({ time_window: this.state.time_window });
    this.setState({ myDashboard: data });
  };
  update_time_window = async (time_window) => {
    await this.setState({ time_window });
    await this.fetchMyDashboard();
  };
  render() {
    return _.isNull(this.props.current_user) || _.isNull(this.state.myDashboard) ? (
      <FullPageSpinner />
    ) : (
      <DashboardContents
        time_window={this.state.time_window}
        update_time_window={this.update_time_window}
        current_user={this.props.current_user}
        myDashboard={this.state.myDashboard}
      />
    );
  }
}
export default connect((state) => state)(Dashboard);
